import { render, staticRenderFns } from "./duo_single_select_options.vue?vue&type=template&id=51fa7199"
import script from "./duo_single_select_options.vue?vue&type=script&lang=js"
export * from "./duo_single_select_options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports